/* eslint-disable prettier/prettier */
import {
  NON_PATIENT_ACTIVITY_CREATE_REQUEST,
  NON_PATIENT_ACTIVITY_CREATE_SUCCESS,
  NON_PATIENT_ACTIVITY_CREATE_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants//methods';

export function createNonPatientActivity({ NonPatientActivity }, shouldAssignToday) {
  return {
    types: [
      NON_PATIENT_ACTIVITY_CREATE_REQUEST,
      NON_PATIENT_ACTIVITY_CREATE_SUCCESS,
      NON_PATIENT_ACTIVITY_CREATE_FAILURE,
    ],
    buildCallParameters: () => ({
      method: HTTP_METHOD.POST,
      data: {
        NonPatientActivity,
        shouldAssignToday,
      },
      path: 'v1/command/CreateNonPatientActivity',
    }),
  };
}
